import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import {
  TableCell,
  TableRow
} from '@material-ui/core';
import {
  getRPAChargeCodesUnmappedApi,
  setRPAChargeMappedProductApi
} from 'api';
import { convertUTCDateToLocalDate } from 'helpers/date';
import MapButton from '../ActionButtons/MapButton';
import IgnoreButton from '../ActionButtons/IgnoreButton';
import ChangeMappingModal from '../ChangeMapping/ChangeMappingModal';
import IgnoreMappingModal from '../IgnoreMapping/IgnoreMappingModal';


const UnmappedDataTableRow = ({
  chargeCode,
  sort,
  currentPage,
  rowsPerPage
}) => {
  const dispatch = useDispatch();
  const { name, updated_at } = chargeCode;
  const [openMappingModal, setOpenMappingModal] = useState(false);
  const [openIgnoreModal, setOpenIgnoreModal] = useState(false);

  const handleUpdateMappedItem = async ({chargeName, chargeProductData}) => {
    const {
      catalogName,
      sku,
      revenueCategory1,
      revenueCategory2,
      revenueCategory3,
      revenueCategory4,
      replenishment,
      cost,
      catalogBrand,
      manufacturer,
      loyaltyProgram
    } = chargeProductData;

    const mappedData =   {
      sku,
      name: chargeName,
      cost,
      manufacturer,
      brand: catalogBrand,
      replenishment,
      category1: revenueCategory1,
      category2: revenueCategory2,
      category3: revenueCategory3,
      category4: revenueCategory4,
      loyalty_program: loyaltyProgram,
      catalog_name: catalogName,
      reward_points: 0
    };

    const isChargeMapped = await setRPAChargeMappedProductApi({dispatch, mappedData});

    if (isChargeMapped) {
      getRPAChargeCodesUnmappedApi({
        dispatch,
        sort,
        currentPage,
        rowsPerPage
      });
      setOpenMappingModal(false);
    }
  };

  return (
    <TableRow>
      <TableCell>
        {name}
      </TableCell>
      <TableCell className="whitespace-no-wrap">
        {format(convertUTCDateToLocalDate(updated_at), 'MM/dd/yyyy')}
      </TableCell>
      <TableCell align="right">
        <MapButton
          handleClick={() => setOpenMappingModal(true)}
        />
        <IgnoreButton
          handleClick={() => setOpenIgnoreModal(true)}
        />
        {openMappingModal &&
          <ChangeMappingModal
            chargeName={name}
            open={openMappingModal}
            setOpen={setOpenMappingModal}
            onConfirm={handleUpdateMappedItem}
          />
        }
        {openIgnoreModal &&
          <IgnoreMappingModal
            chargeName={name}
            open={openIgnoreModal}
            setOpen={setOpenIgnoreModal}
            onConfirm={handleUpdateMappedItem}
          />
        }
      </TableCell>
    </TableRow>
  );
};

export default UnmappedDataTableRow;
